<template>
  <fb-form-body>

    <el-form :model="formData" label-width="100px" style="width: 900px">

      <div class="model-row">
        <el-form-item :label="$t('lang.按型号筛选') + '：'">
          <el-checkbox-group v-model="productCodes">
            <el-checkbox :label="i.productCode" v-for="i in productList" :key="i.productCode">{{i.productModel}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" plain @click="handleSearch">{{$t('lang.查找')}}</el-button>
        </el-form-item>

      </div>


      <el-table border :data="tableData" height="500" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

<!--        <el-table-column type="index" width="50"></el-table-column>-->
        <el-table-column prop="recipeCategoryName" :label="$t('lang.分类')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.食谱名称')"></el-table-column>
        <el-table-column prop="number" :label="$t('lang.食谱编号')"></el-table-column>
        <el-table-column :label="$t('lang.支持型号')">
          <template slot-scope="scope">
            <span>{{scope.row.productModels | filterModel}}</span>
          </template>
        </el-table-column>

      </el-table>

      <div style="margin: 14px 0">
        <span>{{$t('lang.共')}}{{ total }}{{$t('lang.条')}}，{{$t('lang.已选')}}{{ selection.length }}{{$t('lang.条')}} </span>
      </div>


      <el-radio-group v-model="batchModel">
        <div class="radio-item">
          <el-radio label="add">{{ $t('lang.批量添加支持型号') }}</el-radio>
          <el-select v-model="formData.addModel" :placeholder="$t('lang.型号')">
            <el-option v-for="i in productList" :key="i.productCode" :label="i.productModel" :value="i.productCode"></el-option>
          </el-select>
        </div>

        <div class="radio-item">
          <el-radio label="del">{{ $t('lang.批量删减支持型号') }}</el-radio>
          <el-select v-model="formData.reModel" :placeholder="$t('lang.型号')">
            <el-option v-for="i in productList" :key="i.productCode" :label="i.productModel" :value="i.productCode"></el-option>
          </el-select>
        </div>
      </el-radio-group>

      <el-form-item>
        <el-button type="primary" @click="handleSave">{{ $t('lang.保存') }}</el-button>
      </el-form-item>

    </el-form>

  </fb-form-body>
</template>

<script>
import {loadBrandOwnerProduct} from "../../js/common";

export default {
  name: "Model",
  data() {
    return {
      api: {
        list: this.$api.recipe.list,
        batchRelModel: this.$api.recipe.batchRelModel,
        batchDeleteModel: this.$api.recipe.batchDeleteModel,
      },
      formData: {
        addModel: [],
        reModel: []
      },
      tableData: [],
      batchModel: 'add',
      total: 0,
      productList: [],
      selection: [],
      productCodes: [],
      searchForm: {
        onPage: false,
        status: 'released',
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
        productCodes: ''
      }
    }
  },
  filters: {
    filterModel(list) {
      if(list.length) {
        return list.join('/');
      }
      return ''
    }
  },
  methods: {
    handleSave() {
      const vm = this;
      if(!this.selection.length) {
        this.$message({type: "warning", message: vm.$t('lang.未选择食谱记录')});
        return;
      }

      if(this.batchModel == 'add' && !this.formData.addModel.length) {
        this.$message({type: "error", message: vm.$t('lang.请选择批量添加支持型号')});
        return;
      }

      if(this.batchModel == 'del' && !this.formData.reModel.length) {
        this.$message({type: "error", message: vm.$t('lang.请选择批量删减支持型号')});
        return;
      }

      let url = this.batchModel == 'add' ? vm.api.batchRelModel : vm.api.batchDeleteModel;
      let data = {
        recipeCodeList: [],
        productCodeList: [this.batchModel == 'add' ? this.formData.addModel : this.formData.reModel],
      }

      this.selection.forEach(item => {
        data['recipeCodeList'].push(item.code);
      });

      vm.$http.post(url, data).then(res => {
        if(res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }

        vm.$message.success(res.data.desc);
      })
    },
    handleSearch() {
      let productCodes = this.productCodes.join(',');
      this.searchForm['productCodes'] = productCodes;
      this.handleGetList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleGetList() {
      const vm = this;
      vm.$http.get(vm.api.list, {params: vm.searchForm}).then(res => {
        if(res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.tableData = res.data.data['recipes'];
        vm.total = res.data.data['pager'].itemCount;
      })

    }
  },
  async created() {
    this.handleGetList();
    this.productList = await loadBrandOwnerProduct(this, this.$store.state.userInfo['brandOwnerCode']);

  }
}
</script>

<style scoped>

.model-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.radio-item {
  margin-bottom: 16px;
}

</style>
